export const products = {
  hero: {
    title: '三大产品赛道',
    subtitle: '覆盖轻养生全场景',
    description: '从口袋里的微型实验室，到还原自然的黑科技，再到新中式朋克养生。膳兜兜用三大产品矩阵，为不同场景的健康需求提供科学解决方案。',
  },
  tracks: [
    {
      name: '功能性软糖与凝胶糖果',
      tagline: '口袋里的微型实验室',
      description: '年轻人接受度最高的轻养生形式。利用微胶囊技术包裹活性成分，解决传统中药口感苦涩的问题。0糖0脂，天然代糖赤藓糖醇。',
      features: ['微胶囊包埋技术', '0糖0脂配方', '天然代糖赤藓糖醇', '迷你铝箔便携装'],
      products: [
        {
          name: '熬夜急救软糖',
          tag: '护肝明目',
          ingredients: ['人参提取物', '葛根提取物', '菊花提取物'],
          target: '加班党、熬夜党',
        },
        {
          name: '美白抗氧爆珠',
          tag: '维C美白',
          ingredients: ['刺梨提取物', '玫瑰提取物', '沙棘提取物'],
          target: '追求美白、抗氧化人群',
        },
        {
          name: '助眠晚安糖',
          tag: 'GABA助眠',
          ingredients: ['酸枣仁', 'GABA', '薰衣草提取物'],
          target: '失眠焦虑人群',
        },
      ],
    },
    {
      name: '冻干即食滋补品',
      tagline: '还原自然的黑科技',
      description: 'FD冻干技术能锁住食材98%以上的营养，是目前高端健康食品的首选工艺。传统需要炖煮4小时，现在只需开水冲泡60秒。',
      features: ['FD冻干锁鲜98%+', '清洁标签无防腐', '60秒即食', '低温破壁易吸收'],
      products: [
        {
          name: '冻干银耳羹 / 燕窝粥',
          tag: '胶质满满',
          ingredients: ['古田银耳', '燕窝', '红枣', '枸杞'],
          target: '美容养颜、润肺人群',
        },
        {
          name: '冻干水果脆片',
          tag: '药食同源',
          ingredients: ['无花果', '黄桃', '桑葚'],
          target: '办公室零食、健康解馋',
        },
        {
          name: '益生菌冻干粉',
          tag: '肠道健康',
          ingredients: ['复合益生菌', '膳食纤维', '低聚果糖'],
          target: '久坐便秘、肠道调理人群',
        },
      ],
    },
    {
      name: '中式草本能量棒 / 烘焙',
      tagline: '新中式朋克养生',
      description: '将传统重口味养生食材进行零食化改造，切入代餐和下午茶场景。控卡技术精准计算每一根棒的热量。',
      features: ['控卡精准计算', '酶解去豆腥', '独立小包装', '药食同源食材'],
      products: [
        {
          name: '黑芝麻丸升级版',
          tag: '以黑养黑',
          ingredients: ['黑芝麻', 'DHA藻油', '益生菌'],
          target: '防脱发、养发人群',
        },
        {
          name: '陈皮红豆 / 茯苓山药糕',
          tag: '健脾祛湿',
          ingredients: ['新会陈皮', '红豆', '茯苓', '山药'],
          target: '湿气重、易疲劳人群',
        },
        {
          name: '高蛋白植物肉脯',
          tag: '低碳环保',
          ingredients: ['大豆蛋白', '豌豆蛋白', '香菇提取物'],
          target: '减脂人群、素食主义者',
        },
      ],
    },
  ],
};